import I18n from '@/locals'
import { ElMessageBox } from 'element-plus'
/**
 * 检查版本更新
 */
let globVersion = false
const checkUpdate = async () => {
  try {
    // 带时间戳请求，防止缓存
    if (!globVersion) {
      const res = await fetch(`/version.json?t=${Date.now()}`)
      const { version } = await res.json()
      const lastVersion = localStorage.getItem('base_singlelogin_version')
      if (!lastVersion) {
        globVersion = false
        localStorage.setItem('base_singlelogin_version', version) // 更新本地版本
      } else if (lastVersion != version) {
        globVersion = true
        localStorage.setItem('base_singlelogin_version', version) // 更新本地版本
        // 检测到新版本，提示用户
        const { t } = I18n.global
        ElMessageBox.alert(t('reload'), t('gentleReminder'), {
          showClose: false,
          confirmButtonText: t('login.confirm'),
          buttonSize: 'default',
          callback: () => {
            globVersion = false
            localStorage.setItem('base_singlelogin_version', version) // 更新本地版本
            window.location.reload(true)
          },
        })
      }
    }
  } catch (error) {
    console.log(error)
  }
}

let checkTimer = null
/**
 * 半小时启动定期检查
 */
export const startPeriodicCheck = () => {
  // 立即执行一次检查
  checkUpdate()
  // 定期检查
  checkTimer = setInterval(() => {
    checkUpdate()
  }, 30 * 60 * 1000)
}
